import DataService from "../../services/DataService";

export default class ClientDataService extends DataService {
  constructor(fbStore) {
    super(fbStore);
  }
}
